import { createAction, props } from '@ngrx/store'
import { NavigationEnd, NavigationStart } from '@angular/router'
import { NavStateContainerBase } from '../../modules/navigation-state'
import { Field, EntityConfiguration } from '../../modules/dto'

export const loadPageStates = createAction('[Page state] Load PageStates')
export const siteStateChanged = createAction(
  '[Page state] site state changed',
  props<{ newState: NavStateContainerBase; isInitialState: boolean }>()
)
export const siteLoaded = createAction('[Page state] site loaded (with token)', props<{ token: string }>())
export const siteStateObsolete = createAction('[Page state] site state is no longer needed', props<{ token: string }>())
export const siteNavigation = createAction(
  '[Page state] Navigation started',
  props<{ navStart: NavigationStart; navEnd: NavigationEnd }>()
)

export const selectDtoType = createAction(
  '[Component state] DTO type selected',
  props<{
    currentDtoType: EntityConfiguration
    headerFields: Field[]
    editableFields: Field[]
    creationFields: Field[]
    excludedPanels: string[]
    // refreshTrigger: Observable<[string, number]>
  }>()
)
export const unSelectDtoType = createAction('[Component state] DTO type cleared')

export const selectEntity = createAction(
  '[Component state] Entity selected',
  props<{
    currentEntity: any[]
    // refreshTrigger: Observable<[string, number]>
  }>()
)
export const unSelectEntity = createAction('[Component state] Entity selection cleared')
